import localeBase from './EstimateSummary.locale';

const locale = Object.assign({}, localeBase, {
  mandiButtonText: 'Order Installation*',
  mandiButtonTextMobile: 'Order Install*',
  mandiText: '*Professional installation requires professional measure.',
});
export default locale;
